import Api from '../api'
import type { Full } from './types'
import { showToast } from '#components/toast'

export interface RatingVoteEventDetails {
  targetType: string,
  targetId: number,
  result: {
    success: boolean,
    message: string,
    voteDirection: '+' | '-',
    value: number
  }
}

export const RatingVote = (targetType: string, targetId: number, value: '+' | '-') => {
  Api.post<RatingVoteEventDetails['result']>({
    url: 'rating/vote',
    body: {
      target_type: targetType,
      target_id: targetId,
      value
    }
  })
    .then(result => {
      let type: 'error' | 'success' = 'error'
      if (result.success) {
        type = 'success'
        const event = new CustomEvent<RatingVoteEventDetails>('sg-rating-vote', {
          detail: {
            targetType,
            targetId,
            result: result as Full<typeof result>
          }
        })
        window.dispatchEvent(event)
      }
      if (result.message) {
        showToast({
          type,
          text: result.message
        })
      }
    })
}
